import { Link } from "react-router-dom";
import { Column } from "react-table";
import { formatDate } from "../../api/DateUtils";
import {
  GetComplaintsFromComplianceInvestigationFetchUrl,
  IComplaint,
} from "../../api/IComplaint";
import { GetComplaintDetailsPageUrl } from "../../leap-pages/routeFactory";
import { Grid } from "../Grid";
import { ComplaintIcon } from "../icons/LeapIcons";
import { ComplaintsGridProps } from "./ComplaintsGridProps";

const ComplaintsGrid = ({
  relatedRecordType,
  relatedrecordId,
  licenceProfile,
}: ComplaintsGridProps) => {
  const getFetchUrlFactory = (relatedId: string) => {
    let fetchUrlFn = (
      pageNo: number,
      recordsPerPage: number,
      searchText: string,
      filters: any
    ) => {
      switch (relatedRecordType) {
        case "CI":
        default:
          return GetComplaintsFromComplianceInvestigationFetchUrl(
            relatedId,
            pageNo,
            recordsPerPage,
            searchText,
            filters
          );
      }
    };

    return fetchUrlFn;
  };

  const fetchUrl = getFetchUrlFactory(relatedrecordId);

  const tableColumnsBig: Column<Record<string, IComplaint>>[] = [
    {
      Header: "Ref. No.",
      accessor: "reference",
      Filter: false,
      filter: "includes",
      Cell: (rowInfo: any) => (
        <table>
          <tr>
            <td style={{ paddingTop: "6px" }}>
              <span>
                <ComplaintIcon />
              </span>
            </td>
            <td>
              <Link
                to={GetComplaintDetailsPageUrl(
                  licenceProfile.profileNo,
                  rowInfo.row.original.complaintid
                )}
              >
                {rowInfo.value}
              </Link>
            </td>
          </tr>
        </table>
      ),
    },
    {
      Header: "Occurred Date",
      accessor: "dateoccurred",
      Filter: false,
      filter: "includes",
      Cell: (rowInfo: any) => formatDate(rowInfo.value),
    },
    {
      Header: "Type",
      accessor: "type",
      Filter: false,
    },
    {
      Header: "Status",
      accessor: "status",
      Filter: false,
      filter: "includes",
    },
  ];

  const tableColumnsSmall: Column<Record<string, IComplaint>>[] = [
    {
      Header: "Ref. No.",
      accessor: "reference",
      Filter: false,
      filter: "includes",
      Cell: (rowInfo: any) => (
        <table>
          <tr>
            <td style={{ paddingTop: "6px" }}>
              <span>
                <ComplaintIcon />
              </span>
            </td>
            <td>
              <Link
                to={GetComplaintDetailsPageUrl(
                  licenceProfile.profileNo,
                  rowInfo.row.original.complaintid
                )}
              >
                {rowInfo.value}
              </Link>
            </td>
          </tr>
        </table>
      ),
    },
    {
      Header: "Occurred Date",
      accessor: "dateoccurred",
      Filter: false,
      filter: "includes",
      Cell: (rowInfo: any) => formatDate(rowInfo.value),
    },
    {
      Header: "Status",
      accessor: "status",
      Filter: false,
      filter: "includes",
    },
  ];

  var bodyElements = (
    <div>
      <div className="d-md-none">
        <Grid
          columns={tableColumnsSmall}
          data={[]}
          fetchUrlFunction={fetchUrl}
          enablePagination={true}
          enableQuickFind={true}
        />
      </div>
      <div className="d-none d-md-block">
        <Grid
          columns={tableColumnsBig}
          data={[]}
          fetchUrlFunction={fetchUrl}
          enablePagination={true}
          enableQuickFind={true}
        />
      </div>
    </div>
  );

  return bodyElements;
};

export { ComplaintsGrid };
